import React from 'react'
import {Bg} from '../field'
import FieldRenderer from '../field/FieldRenderer'
import Block from './Block'

const BlockRenderer = (props) => {
	const {entity, block, menu, childBlocks, config} = props
	let fields = config.fields
	let entityFields = config.entityFields
    //console.log('renderer',block, entity)
	return (
	<div id={config.id}
		className={config.classes.join(' ')}
		style={config.style}>
		{config.bg && <Bg bg={config.bg} imageStyle={config.bgStyle} proportional={config.classes.includes('bg-prop')} container={`#${config.id} > .block-in`} config={config} />}
		{menu}
	    <div className='block-in'>
              {block.type==='hero' && entity.bundle==='article' && entity.project===1 && <img src="https://scoalalacrima.ro/img/pocu.svg" className="pocuimg" alt=""/>}
              {block.type==='hero' && entity.bundle==='article' && entity.project===2 && <img src="https://scoalalacrima.ro/img/erasmus.svg" className="erasmusimg" alt=""/>}
              <div className={config.contentClasses.join(' ')} style={config.contentStyle}>
			{childBlocks}
			{config.groups.map((group, i) => 
				<div key={i} className={`group group-${group.name}`}><div className='group-in'>
					{group.fields.map((f, j) => {
						let fs = fields.filter(field => field.name===f)
						if (fs.length>0) {
							let field = fs[0]
							fields = fields.filter(field => field.name!==f)
							return <FieldRenderer key={j} field={field} value={block[field.name]} path={field.name} {...props}/>
						}
						return null
					})}
				</div></div>
			)}
			{fields.map((field, i) => <FieldRenderer key={i} field={field} value={block[field.name]} path={field.name} {...props}/>)}
			{entityFields.map((field, i) => 
				<FieldRenderer key={i} field={field} value={entity[field.name]} type='entity' path={field.name} {...props}/>
			)}
			{config.extensions.map((Ext, i) => <Ext key={i} {...props}/>)}
			{config.grid && entity.grid.filter(block => !block.p).map((block,i) => 
				<Block key={i} entity={entity} block={block}/>)}
		</div></div>
	</div>
)}
export default BlockRenderer



// WEBPACK FOOTER //
// ./src/fm/block/BlockRenderer.js